import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useMQ } from '@/js/lib/helper/media-query';
import { NativeView, urlForDeepLink } from '@/js/lib/helper/yappli';
import { credentials } from '@/js/lib/api/user';
import { useCartStore } from '@/js/lib/store/cart';
import { useUserStore } from '@/js/lib/store/user';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupCompleteModal',
  props: {
    fromNative: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  fromNative?: boolean;
};



const userStore = useUserStore();
const cartStore = useCartStore();
const isPreSeller = userStore.hasCredential(credentials.preSeller);
const isSeller = userStore.hasCredential(credentials.seller);
const { isSp } = useMQ();
const itemInCart = computed(() => cartStore.itemCount > 0);
const textOk = computed(() => {
  let text = '';
  if (props.fromNative && isSp.value) {
    text = 'アプリに戻る';
  } else if (isSeller) {
    text = 'マイページ';
  } else if (isPreSeller) {
    text = 'ショップを開設する';
  } else if (itemInCart.value) {
    text = 'カートに進む';
  }
  return text;
});
const onOK = () => {
  if (props.fromNative && isSp.value) {
    window.location.href = itemInCart.value ? urlForDeepLink(NativeView.CART) : urlForDeepLink(NativeView.WEBVIEW, { url: window.location.href });
  } else if (isPreSeller) {
    window.location.href = '/your/shop/setup';
  } else if (isSeller) {
    window.location.href = '/your/dashboard';
  } else if (itemInCart.value) {
    window.location.href = '/cart';
  }
};
const modalClose = () => {
  emit('close');
};

return { __sfc: true,props, emit, userStore, cartStore, isPreSeller, isSeller, isSp, itemInCart, textOk, onOK, modalClose, IModal }
}

})